import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import Servicii from "./pages/Servicii";
import Preturi from "./pages/Preturi";
import Rezervari from "./pages/Rezervari";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/servicii" element={<Servicii />} />
          <Route path="/preturi" element={<Preturi />} />
          <Route path="/rezervari" element={<Rezervari />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
        <Toaster
          position="bottom-right"
          theme="light"
          richColors={false}
          toastOptions={{
            style: {
              background: "#FFFFFF",
              border: "1px solid #E8E0D5",
              color: "#1A1A1A",
              fontFamily: "'Jost', sans-serif",
              borderRadius: 0,
              boxShadow: "0 2px 20px rgba(0,0,0,0.05)",
            },
            className: "lumiere-toast",
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
